<div class="attribute-editor-component" rvSpinner="schedules-component-spinner" [rvShowSpinner]="scheduleSelectorService.loadingSchedules">
  <div class="attribute-editor-row">
    <label class="text-sm mb-3">Which schedule(s) should this presentation show on?</label>

    <schedule-selector></schedule-selector>

  </div>
</div>
